module.exports = __webpack_public_path__ + "static/img/nucleo-icons.dc0cdfa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nucleo-icons.svg
// module id = RcMz
// module chunks = 4